import React from "react";

// Premi-Skills monogram: twin brackets enclosing a ledger bar glyph with a vermilion pulse node.
export const Logo = ({ className = "", size = 28 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Premi-Skills"
  >
    {/* left bracket */}
    <path d="M9 4H4V28H9" stroke="currentColor" strokeWidth="2.4" strokeLinecap="square" />
    {/* right bracket */}
    <path d="M23 4H28V28H23" stroke="currentColor" strokeWidth="2.4" strokeLinecap="square" />
    {/* ledger bars */}
    <rect x="12.5" y="10" width="7" height="2.4" fill="currentColor" />
    <rect x="12.5" y="15" width="7" height="2.4" fill="currentColor" />
    <rect x="12.5" y="20" width="4" height="2.4" fill="currentColor" />
    {/* pulse node */}
    <circle cx="26" cy="6" r="2.6" fill="#FF3B30" />
  </svg>
);

export default Logo;
